import { dashboardBuild as activityBuild } from './dashboards/Activities/build';
import { queries as activityQueries } from './dashboards/Activities/queries';

export const dashboardBuild = (
    type: string,
    code?: string,
    config?: any,
    setFilters?: any
) => {
    if (type === 'activity') {
        return {
            tabs: [
                {
                    label: 'Activities',
                    builder: activityBuild(setFilters),
                    queries: activityQueries,
                },
            ],
        };
    }
};
